import { connect } from 'react-redux';
import PrConfirmation from './prConfirmation';
import { bindActionCreators } from 'redux';
import {
    getServiceRequestedQty,saveServiceQuanity,getServiceQuantityConfirmation
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    servicesQty: state.siteListingReducer.servicesQty,
    servicesQtyConfirmation: state.siteListingReducer.servicesQtyConfirmation,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getServiceRequestedQty,
      saveServiceQuanity,
      getServiceQuantityConfirmation
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PrConfirmation);
